<template>
  <IAMEntityInfoTab :model="model" :show-name="true" :show-active="true" />
</template>

<script setup lang="ts">
import { Tenant } from '@infuse/api/iam/tenant';
import { IAMEntityInfoTab } from '@infuse/iam/components';

const props = defineProps<{
  model: Tenant;
}>();
</script>
